import { render, staticRenderFns } from "./ExpertView.vue?vue&type=template&id=c72606da&scoped=true&"
import script from "./ExpertView.vue?vue&type=script&lang=js&"
export * from "./ExpertView.vue?vue&type=script&lang=js&"
import style0 from "./ExpertView.vue?vue&type=style&index=0&id=c72606da&lang=scss&scoped=true&"
import style1 from "./ExpertView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72606da",
  null
  
)

export default component.exports